<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10">Nota dell’autore</h1>
<p class="p6"><img alt="img3.png" src="Images/img3.png"/></p>
<p class="p7"> </p>
<p class="p7"><span class="t4">Salvare Sean</span> è il secondo romanzo della serie Storie di Seattle. Ogni libro può essere letto come una storia autonoma. Tuttavia, se desiderate leggere gli intrecci di questo gruppo di amici in ordine cronologico, cominciate con <span class="t4">Dopo Ben</span>, disponibile sempre presso Dreamspinner Press.</p>
<p class="p7"> </p>
<p class="p8">Con Riley</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?5b84677f